<template>
  <div
    class="accordion border-[1px] p-4 rounded-lg border-[#c3c3c3]"
  >
    <div class="tab__header">
      <button
        class="tab__link w-100 no-underline flex justify-between"
        @click="setActive"
      >
        <p class="text-base font-semibold text-left">
          <slot name="title" />
        </p>
        <span class="icons flex flex-row items-center">
          <Circle v-if="icon" class="w-6 h-6 me-3" :class="`bg-${color}`"/>
          <ChevronLeft class="icon-arrow w-5 h-5" :class="active ? 'rotate' : ''" color="black"/>
        </span>
      </button>
      <slot name="desc" />
      <div class="outer" :style="`max-height:${height}px`" ref="outer">
        <p class="text-small text-gray-600 inner">
          <slot name="body" />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import ChevronLeft from '@/components/icons/ChevronLeft.vue';
import Circle from '@/components/icons/Circle.vue';

export default {
  name: 'AccordionItem',
  components: {
    ChevronLeft,
    Circle,
  },
  props: {
    icon: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'success',
    },
  },
  methods: {
    setActive() {
      this.active = !this.active;
      if (this.active) {
        this.height = this.$refs.outer.scrollHeight;
      } else {
        this.height = 0;
      }
    },
  },
  data() {
    return {
      active: false,
      height: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
.tab__link {
  width: 100%;
}
.outer {
  overflow: hidden;
  transition: all 0.3s ease;
}

.icon-arrow {
  transform: rotate(-90deg);
  transition: all 0.3s ease;

  &.rotate {
    transform: rotate(90deg);
  }
}
</style>
